import { render, staticRenderFns } from "./FutureLayerDaysRemainingBadge.vue?vue&type=template&id=531d415f&"
import script from "./FutureLayerDaysRemainingBadge.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerDaysRemainingBadge.vue?vue&type=script&lang=ts&"
import style0 from "./FutureLayerDaysRemainingBadge.vue?vue&type=style&index=0&id=531d415f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports